import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ e('<path fill="#FFDA44" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#6DA544" d="M32.176 4.134A19.91 19.91 0 0 0 20 0 19.91 19.91 0 0 0 7.824 4.134L20 16.311 32.176 4.134Z"></path><path fill="#000" d="M4.134 7.824A19.91 19.91 0 0 0 0 20c0 4.582 1.542 8.804 4.135 12.176L16.31 20 4.134 7.824Z"></path><path fill="#6DA544" d="M7.824 35.866A19.91 19.91 0 0 0 20 40a19.91 19.91 0 0 0 12.176-4.134L20 23.689 7.824 35.867Z"></path><path fill="#000" d="M35.866 32.176A19.91 19.91 0 0 0 40 20a19.91 19.91 0 0 0-4.134-12.176L23.689 20l12.177 12.176Z"></path>', 5), c = [
  o
];
function h(i, n) {
  return t(), a("svg", l, [...c]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
